import { useEffect, useState } from "react";
import { useLang } from "../i18n";

const TARGET = new Date("2026-12-13T00:30:00Z").getTime(); // Dec 12, 2026 7:30 PM Haiti (UTC-5)

const pad = (n) => String(n).padStart(2, "0");

export const Countdown = ({ compact = false }) => {
    const { t } = useLang();
    const [now, setNow] = useState(Date.now());

    useEffect(() => {
        const id = setInterval(() => setNow(Date.now()), 1000);
        return () => clearInterval(id);
    }, []);

    const diff = Math.max(0, TARGET - now);
    const days = Math.floor(diff / 86400000);
    const hours = Math.floor((diff % 86400000) / 3600000);
    const minutes = Math.floor((diff % 3600000) / 60000);
    const seconds = Math.floor((diff % 60000) / 1000);

    const cells = [
        { v: days, l: t("cd_days") },
        { v: hours, l: t("cd_hours") },
        { v: minutes, l: t("cd_minutes") },
        { v: seconds, l: t("cd_seconds") }
    ];

    return (
        <div data-testid="countdown-timer" className={`grid grid-cols-4 ${compact ? "gap-2 max-w-sm" : "gap-2 sm:gap-3 max-w-xl"}`}>
            {cells.map((c) => (
                <div key={c.l} className={`rounded-xl border border-lakou-gold/25 bg-lakou-coal/80 backdrop-blur-md text-center ${compact ? "px-2 py-3" : "px-2 py-4 sm:py-5"}`}>
                    <div className={`font-display font-black text-goldgrad tabular-nums ${compact ? "text-2xl" : "text-3xl sm:text-5xl"}`}>
                        {pad(c.v)}
                    </div>
                    <div className="mt-1 font-mono2 text-[9px] sm:text-[10px] uppercase tracking-[0.25em] text-lakou-sand">{c.l}</div>
                </div>
            ))}
        </div>
    );
};
